import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { useAddFaqsMutation, useUpdateFaqsMutation } from "../../Data/services/faqApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import BeatLoader from "react-spinners/BeatLoader";
import { Controller, useForm } from "react-hook-form";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import _ from "lodash";

const EditFAQModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [order, setOrder] = useState(0);
  const [sending, setSending] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState();

  const { handleSubmit, control, setValue } = useForm({});

  const statusList = [
    { label: "YES_NO", value: 10 },
    { label: "TEXT", value: 20 },
    { label: "DONE", value: 30 },
  ];

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      setRowId(editData.id);
      setQuestion(editData.question);
      setSelectedStatus(editData.type);
      setValue('type', editData.type);
    }
  }, [editData, mounted]);


  const handleQuestion = (e) => {
    console.log(e.target.value);
    setQuestion(e.target.value);
  };

  const handleAnswer = (e) => {
    console.log(e.target.value);
    setAnswer(e.target.value);
  };

  const handleOrder = (e) => {
    console.log(e.target.value);
    setOrder(e.target.value);
  };

  const [addReportType, { isLoading: adding }] = useAddFaqsMutation();
  const [updateReportType, { isLoading: updating }] = useUpdateFaqsMutation();

  const onSubmit = async (e) => {
    const data = {
      type: Number(e.type),
      question: question,
    };

    setSending(true);
    try {
      let response;
      if (editData) {
        response = await updateReportType({ data, slug: rowId });
      } else {
        response = await addReportType(data);
      }

      if (response.data.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.data?.message) || Toast('FAQ`s Updated Successfully', "success");
        handleEditModalClose();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } 
      handleEditModalClose();
      setSending(false);
    } finally {
      refetch();
    }

  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose} >
        <div className={cssStyles.modalContainer} style={{minWidth: "40%"}}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">
              {editData ? "Edit Question" : "Add Question"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
          <Form onSubmit={handleSubmit(onSubmit)}>
             <Row>
                <Col md={12}>
                  <p className="m-0 black-text">Question Type</p>
                  <Controller
                    control={control}
                    name="type"
                    rules={{}}
                    defaultValue={selectedStatus}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <SelectFieldComponent
                        firstOption={
                          _.isEmpty(selectedStatus)
                            ? "Select Question Type"
                            : selectedStatus
                        }
                        optionsList={statusList}
                        onSelectChange={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Input
                    classes="mt-2 mb-3"
                    type="textarea"
                    rows={5}
                    as="textarea"
                    name="question"
                    placeholder="Enter question"
                    value={question}
                    onChange={handleQuestion}
                  />
                </Col>
              </Row>
            {
            //   <Row>
            //     <Col md={12}>
            //       <Input
            //         classes="mt-2 mb-3"
            //         type="textarea"
            //         rows={5}
            //         as="textarea"
            //         name="answer"
            //         placeholder="Enter answer"
            //         value={answer}
            //         onChange={handleAnswer}
            //       />
            //     </Col>
            //   </Row>
            }
            {
              // <Row>
              //   <Col md={12}>
              //     <Input
              //       classes="mt-2 mb-3"
              //       type="number"
              //       name="order"
              //       min={0}
              //       placeholder="Enter order number"
              //       value={order}
              //       onChange={handleOrder}
              //     />
              //   </Col>
              // </Row>
            }

            <Row>
              <Col md={12}>
                <Button
                  classes={`${cssStyles.cardBtn} mt-4 `}
                  text={
                    sending ? (
                    <BeatLoader size={10} />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  onClick={handleSubmit}
                  disabled={question == ''}
                ></Button>
              </Col>
            </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditFAQModal;